import { useState, useEffect } from "react";
import InterfaceTable from "../../Table/InterfaceTable";
import { Space, message } from "antd";
import { EyeOutlinedIcon } from "../../Utils/UI/Text";
import Formatter from "../../Data/Domain/Formatter";

const SDGBoard = ({ sdg, getSDG, totalSDG }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    page: 0,
    limit: 20,
  });
  const [filters, setFilters] = useState({});

  useEffect(() => {
    fetchData({ page: values.page, limit: values.limit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalSDG]);

  const columnsSDG = [
    {
      title: "Código",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Acciones",
      dataIndex: "",
      key: "acciones",
      render: (_, record) => (
        <Space size="middle">
          {record.url ? (
            <a href={record.url} target="_blank" rel="noopener noreferrer">
              <EyeOutlinedIcon TooltipEyeOutlined="Ver Imagen" />
            </a>
          ) : (
            <span style={{ color: "#ccc" }}>Sin imagen</span>
          )}
        </Space>
      ),
    },
  ];

  const fetchData = async (params = {}) => {
    try {
      setLoading(true);

      const finalParams = {
        limit: values.limit,
        page: values.page,
        ...params,
      };

      await getSDG(finalParams);
      setLoading(false);
    } catch (error) {
      message.error("Error al cargar los datos");
      setLoading(false);
    }
  };

  const handleRequest = (newPagination = {}, newFilters = {}, sorter = {}) => {
    const { current = 1, pageSize = values.limit } = newPagination;

    const updatedValues = {
      page: current - 1,
      limit: pageSize,
    };
    setValues(updatedValues);

    const cleanParams = Formatter.cleanParamsFromTableToAPI({
      ...newFilters,
      limit: updatedValues.limit,
      page: updatedValues.page,
      dates: [],
    });

    setFilters(newFilters);
    fetchData(cleanParams);
  };

  useEffect(() => {
    fetchData({
      limit: values.limit,
      page: values.page,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <InterfaceTable
        rowKey="_id"
        onChange={handleRequest}
        pagination={{
          pageSize: values.limit,
          current: values.page + 1,
          total: columnsSDG,
          showSizeChanger: true,
          pageSizeOptions: [ "20", "50", "100"],
          onShowSizeChange: (current, size) => {
            const updatedValues = {
              page: current - 1,
              limit: size,
            };
            setValues(updatedValues);
            fetchData({
              page: updatedValues.page,
              limit: updatedValues.limit,
            });
          },
        }}
        data={sdg}
        columns={columnsSDG}
        loading={loading}
      />
    </div>
  );
};

export default SDGBoard;
